import daLanguage from './da-language.mp4';
import deLanguage from './de-language.mp4';
import enLanguage from './en-language.mp4';
import enUSLanguage from './en-US-language.mp4';
import esLanguage from './es-language.mp4';
import esMXLanguage from './es-MX-language.mp4';
import frLanguage from './fr-language.mp4';
import itLanguage from './it-language.mp4';
import jaLanguage from './ja-language.mp4';
import jaRomajiLanguage from './ja-romaji-language.mp4';
import koLanguage from './ko-language.mp4';
import mnLanguage from './mn-language.mp4';
import noLanguage from './no-language.mp4';
import ptLanguage from './pt-language.mp4';
import ruLanguage from './ru-language.mp4';
import slLanguage from './sl-language.mp4';
import svLanguage from './sv-language.mp4';
import zhLanguage from './zh-CN-language.mp4';
import yoLanguage from './yo-language.mp4';

const videos: { [k: string]: string } = {
  da: daLanguage,
  de: deLanguage,
  en: enLanguage,
  'en-US': enUSLanguage,
  es: esLanguage,
  'es-MX': esMXLanguage,
  fr: frLanguage,
  it: itLanguage,
  ja: jaLanguage,
  'ja-romaji': jaRomajiLanguage,
  ko: koLanguage,
  mn: mnLanguage,
  no: noLanguage,
  pt: ptLanguage,
  ru: ruLanguage,
  sl: slLanguage,
  sv: svLanguage,
  'zh-CN': zhLanguage,
  yo: yoLanguage,
};

export const getLanguageVideo = (languageLocale: string): string | undefined =>
  videos[`${languageLocale}`];
